import React, {useEffect} from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import GlobalPlayer from '../GlobalPlayer/GlobalPlayer';

import ProtectedLayout from '../Layout/ProtectedLayout/ProtectedLayout';

const ProtectedRoute = ({ component: Component, title, showBack }) => {

	useEffect(() => {
		document.title = title || '';
	}, [title]);
	
	return <Route
		render={(props) => {
			//here you can apply condition
			if (!localStorage.getItem('token')) {
				return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
			}
			
			return <ProtectedLayout showBack={showBack} >
				<Component {...props} />
			</ProtectedLayout>;
		}}
	/>
};

export default withRouter(ProtectedRoute);
